import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaneTableRow } from '../../../../../models/lane.model';
import { ConfirmActionModalComponent } from '../../../../../../shared/components/confirm-action-modal';

@Component({
  selector: 'app-delete-lane-modal',
  standalone: true,
  imports: [CommonModule, ConfirmActionModalComponent],
  templateUrl: './delete-lane-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-lane-modal.component.scss'],
})
export class DeleteLaneModalComponent {
  @Input() lane: LaneTableRow | null = null;
  @Input() isSubmitting = false;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<LaneTableRow>();

  onClose(): void {
    if (this.isSubmitting) {
      return;
    }
    this.close.emit();
  }

  onConfirm(): void {
    if (this.lane && !this.isSubmitting) {
      this.confirm.emit(this.lane);
    }
  }
}
